export const REDUCER_NAME = "competitionTopScorers";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONTOPSCORERS = `${REDUCER_NAME}/SET_COMPETITIONTOPSCORERS`;

export const getKey = (data) =>
  `${data.competitionId}_${data.season ?? "current"}`;
